import apiFetch from '../apiFetch'

export default function (token, repairshop) {
  return apiFetch({ endPoint: 'RepairShop', method: 'POST', body: repairshop, token: token })
}
